import React from 'react';
import styled from '@emotion/styled';
import { ArrowLink, contentWrapBreakpoint } from '../../../../../ui';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { Section } from '../../../../content-sections/ui/components/Section';
import {
	ModifyGuestBookingDialogRoute,
	PARKING_MODIFY_GUEST_BOOKING_HASH_PATTERN,
} from '../guest-booking/ModifyGuestBookingDialogRoute';
import { BookingDetailsDialogRoute } from '../details';
import { useMyBookingsStore } from '../../../domain/booking/stores/useMyBookingsStore';
import Responsive from '../../../../../ui/utils/Responsive';

export const GuestActions = () => {
	const { t } = useTranslation();
	const myBookingsStore = useMyBookingsStore();

	const handleClick = () => {
		// Make sure we always start with a fully reset guest booking
		myBookingsStore.resetGuestBooking();
	};

	return (
		<>
			<StyledGuestActions>
				<h3>{t('parking_landing_change_booking_title')}</h3>
				<p>{t('parking_landing_change_booking_text')}</p>
				<ArrowLink
					href={PARKING_MODIFY_GUEST_BOOKING_HASH_PATTERN}
					onClick={handleClick}
				>
					{t('parking_landing_change_booking_button')}
				</ArrowLink>
			</StyledGuestActions>
			<BookingDetailsDialogRoute />
			<ModifyGuestBookingDialogRoute />
		</>
	);
};

const StyledGuestActions = styled(Section)`
	margin-top: 40px;
	padding-top: 0;
	padding-bottom: 0;

	@media (${contentWrapBreakpoint}) {
		margin-top: 24px;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-top: 16px;
	}
`;
